import React from "react";


const Help = ({
    isDeviceOn
}) => {
    // 

  
    return (
      <div>
        <div 
        className="helpPower neu"
        style={{
            display: isDeviceOn ? "none" : "block"
        }}
        >
            <div className="helpContent">
            <div className="statusIcon"></div>
                <p><span className="helpTitle">The device is off.</span>< br></br>Hold down the start button for 2 seconds to power on the device.</p>
            </div>
            
        </div>
        <div 
        className="helpCountUp neu">
            <div className="helpContent">
                <h3 className="helpTitle">Stop Watch Mode</h3>
                <p>Set any timer to 00:00 by holding down the reset button and then press the start button to start counting.</p>
            </div>
            
        </div>
        <div 
        className="helpTones neu">
            <div className="helpContent">
                <h3 className="helpTitle">About the tones</h3>
                <p>The virtual timer has more tones for purpose the of testing. The final product will include 5 of the most popular tones. Please vote for your favourite tones by leaving feedback.</p>
            </div>
        </div>
        <div 
        className="helpVirtual neu">
            <div className="helpContent">
                <h3 className="helpTitle">About the app</h3>
                <p>This app is a close representation of the actual timer in logic & function.</p>
            </div>
        </div>
      </div>
    );
  };
  
  export default Help;